<template>
  <!-- 
   top: 2.8rem; 
  -->
  <div class="keyboardContainer" :style="{top:fiedTop,zIndex:zindex}">
    <div class="simple-keyboard-main"></div>
    <div class="numPad">
      <div class="simple-keyboard-numpad"></div>
      <div class="simple-keyboard-numpadEnd"></div>
    </div>
    <div class="retract-keyboard">
      <p @click="$emit('close')">
        <i class="el-icon-arrow-down"></i>收起键盘
      </p>
    </div>
  </div>
</template>
<script>
import Keyboard from 'simple-keyboard'
import 'simple-keyboard/build/css/index.css'

export default {
  name: 'simpleKeyboard',
  props: {
    input: {
      type: String
    },
    fiedTop: {
      type: String,
      default: '1.1rem'
    },
    zindex: {
      type: Number,
      default: 99
    }
  },
  data() {
    return {
      keyboard: null,
      keyboardNumPad: null,
      keyboardNumPadEnd: null
    }
  },
  watch: {
    input(input) {
      this.keyboard.setInput(input)
    }
  },
  mounted() {
    let commonKeyboardOptions = {
      onChange: input => this.onChange(input),
      onKeyPress: button => this.onKeyPress(button),
      theme: "simple-keyboard hg-theme-default hg-layout-default",
      physicalKeyboardHighlight: true,
      syncInstanceInputs: true,
      mergeDisplay: true,
      debug: false
    }
    this.keyboard = new Keyboard(".simple-keyboard-main", {
      ...commonKeyboardOptions,
      layout: {
        default: [
          "Q W E R T Y U I O P {backspace}",
          'A S D F G H J K L {enter}',
          "{shiftleft} Z X C V B N M . - / |",
          "{space}"
        ],
        shift: [
          "q w e r t y u i o p {backspace}",
          "a s d f g h j k l {enter}",
          "{shiftleft} z x c v b n m . _ / \\",
          "{space}"
        ]
      },
      display: {
        "{backspace}": "Backspace ⌫",
        "{enter}": "Enter ↵",
        "{capslock}": "caps lock ⇪",
        "{shiftleft}": "shift ⇧",
        "{shiftright}": "shift ⇧",
      }
    })

    this.keyboardNumPad = new Keyboard(".simple-keyboard-numpad", {
      ...commonKeyboardOptions,
      layout: {
        default: [
          "{numpad7} {numpad8} {numpad9}",
          "{numpad4} {numpad5} {numpad6}",
          "{numpad1} {numpad2} {numpad3}",
          "{numpad0} {numpaddecimal}"
        ]
      }
    })
    // this.keyboard = new Keyboard(this.keyboardClass, {
    //   onChange: this.onChange,
    //   onKeyPress: this.onKeyPress
    // })
  },
  methods: {
    onChange(input) {
      this.$emit('onChange', input)
    },
    onKeyPress(button) {
      this.$emit('onKeyPress', button)
      if (button === "{shift}" || button === "{lock}" || button === "{shiftleft}" || button === "{shiftright}") this.handleShift()
    },
    handleShift() {
      let currentLayout = this.keyboard.options.layoutName;
      let shiftToggle = currentLayout === "default" ? "shift" : "default"

      this.keyboard.setOptions({
        layoutName: shiftToggle
      })
    }
  }
}
</script>
<style scoped>
.keyboardContainer {
  position: fixed;
  top: 1.1rem;
  left: 0;
  width: 100%;
  z-index: 99;
  padding: 10px;
  background-color: #fff;
  padding-bottom: 60px;
}
.retract-keyboard {
  position: absolute;
  bottom: 0;
  display: flex;
  line-height: 40px;
  padding-bottom: 10px;
  justify-content: center;
  align-items: center;
}
</style>